
export default {
  name: 'ButtonMinus',
  props: {
    iconSize: {
      type: Number,
      default: () => 20,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickHandler() {
      this.$emit('onDecreaseQty')
    },
  },
}
